import { BaseState } from './BaseState';
import { Subject, BehaviorSubject } from 'rxjs';
import { ObjectTypes } from '../enums';

/**
 * Manages drawing mode state
 */
export class DrawingModeState extends BaseState {
  // RxJS subjects for reactive state management
  public drawingMode$ = new BehaviorSubject<string>(ObjectTypes.line);

  private state = {
    drawingMode: ObjectTypes.line,
  };

  constructor() {
    super();
  }

  getState() {
    return { ...this.state };
  }

  updateState(updates: Partial<typeof this.state>) {
    this.state = { ...this.state, ...updates };
    this.emitStateChange(this.state);
  }

  getDrawingMode(): string {
    return this.state.drawingMode;
  }

  setDrawingMode(mode: string) {
    this.state.drawingMode = mode;
    this.drawingMode$.next(mode);
  }
}
